import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import { useQuery } from "@tanstack/react-query";
import UsersService from "@velocity-ehs/user-utils-module";
import { localesQuery } from "../components/supportFunctions/graphql/TranslationQueries";
import { OptionType } from "../components/routeComponents/UserManagement/User";
import { languagesList } from "../components/routeComponents/UserManagement/UserPreference";
import { useMemo } from "react";
import i18n from "../translations/i18n";

function useLocales(enableTranslationsQuery: boolean) {
  const { showSnackbar } = useSnackbarActionContext();
  const resources = useMemo(() => {
    return i18n.options.resources ?? ({} as Object);
  }, []);

  const result = useQuery({
    queryKey: ["locale"],
    queryFn: () =>
      UsersService.i18nService.translationsApi.post(
        "/graphql?query=getLocales",
        localesQuery()
      ),
    enabled: enableTranslationsQuery,
    retry: false,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  if (!enableTranslationsQuery) {
    return Object.keys(resources).map((lang) => {
      return {
        value: lang,
        label: languagesList[lang],
      } as OptionType;
    });
  }

  const data = result.data?.data?.data?.locales || [];

  return data.map((locale) => {
    return {
      value: locale.code,
      label: `${locale.displayName} (${locale.code})`,
    } as OptionType;
  });
}

export { useLocales };
